import * as angular from 'angular';
import merchantsRouter from './merchants.router';
import countryService from '../common/services/country.service';
import destinationService from '../common/services/destination.service';
import merchantCategoriesService from './merchant-categories.service';
import googleMapsHelper from '../common/googleMaps.helper';
import switchToBcService from '../common/services/switchToBc.service';
import merchantImagesService from './images/images.service';
import servicesService from './services/services.service';
import { SERVICE_STATUSES } from './services/services.constants';
import { DOCUMENT_STATUSES } from './documents/documents.constants';
import documentsService from './documents/documents.service';
import areasService from './areas/areas.service';
import objectsService from './areas/objects.service';
import employeesService from './employees/employees.service';
import settingsService from './settings/settings.service';
import { SETTING_GROUPS, DISABLED_SETTINGS } from './settings/settings.constants';
import generalSettingsService from './settings/generalSettings.service';
import GeneralSettingFactory from './settings/generalSettings.model';
import combinationsService from './combinations/combinations.service';
import openingTimesService from './opening-times/opening-times.service';
import timesService from './opening-times/times.service';
import retentionSettingsService from './retention-settings/retention-settings.service';
import sortableHelper from '../common/sortable.helper';
import roleHelper from '../common/roleHelper.helper';
import slugifyService from '../common/services/slugify.service';
import serviceCategoriesService from './services/service-categories.service';
import merchantService from './merchant.service';
import searchTagsService from '../common/tags/searchTags.service';
import { RETENTION_LENGTH_OPTIONS } from './retention-settings/retention-settings.constants';
import openTableService from 'OpsCenter/merchants/opentable/opentable.service';
import ivrService from 'OpsCenter/merchants/ivr/ivr.service';

import ecCustomersCsv from './customers-download.directive';
import cuisinesTags from '../common/tags/cuisinesTags.component';
import { EMPLOYEES_CONSTANTS } from './employees/employees.constants';
import { COMBINATION_OPTIONS } from './combinations/combinations.constants';
import roleService from '../common/services/role.service';
import { MERCHANT_CONSTANTS } from './merchant.constants';

import ObjectsController from './areas/objects.controller';
import MerchantPortalConfigurationController from './merchant.portal-configuration.controller';
import OpeningTimesController from './opening-times/opening-times.controller';
import SearchTagsController from './searchTags/searchTags.controller';
import MerchantImagesController from './images/images.controller';
import ServicesController from './services/services.controller';
import AreasController from './areas/areas.controller';
import EmployeesController from './employees/employees.controller';
import GeneralSettingsController from './settings/generalSettings.controller';
import CombinationsController from './combinations/combinations.controller';
import RetentionSettingsController from './retention-settings/retention-settings.controller';
import DocumentsController from './documents/documents.controller';
import ServicesTabsController from 'OpsCenter/merchants/services/services-tabs/services-tabs.controller';
import { downgradeComponent } from '@angular/upgrade/static';
import { BlockTablesModalComponent } from 'OpsCenter/merchants/areas/block-tables-modal/block-tables-modal.component';
import { ApprovalPopupComponent } from 'OpsCenter/shared/components/approval-popup/approval-popup.component';

/** @constant {angular.module} */
const merchantsModule = angular
  .module('ec.opsCenter.merchants', [])
  .config(merchantsRouter)
  .service('merchantService', merchantService)
  .service('countryService', countryService)
  .service('destinationService', destinationService)
  .service('merchantCategoriesService', merchantCategoriesService)
  .service('googleMapsHelper', googleMapsHelper)
  .service('switchToBcService', switchToBcService)
  .service('merchantImagesService', merchantImagesService)
  .service('servicesService', servicesService)
  .service('documentsService', documentsService)
  .service('areasService', areasService)
  .service('objectsService', objectsService)
  .service('employeesService', employeesService)
  .service('settingsService', settingsService)
  .service('generalSettingsService', generalSettingsService)
  .service('combinationsService', combinationsService)
  .service('openingTimesService', openingTimesService)
  .service('timesService', timesService)
  .service('retentionSettingsService', retentionSettingsService)
  .service('sortableHelper', sortableHelper)
  .service('roleHelper', roleHelper)
  .service('slugifyService', slugifyService)
  .service('serviceCategoriesService', serviceCategoriesService)
  .service('merchantService', merchantService)
  .service('roleService', roleService)
  .service('searchTagsService', searchTagsService)
  .service('openTableService', openTableService)
  .service('ivrService', ivrService)
  .factory('GeneralSetting', GeneralSettingFactory)
  .factory('SERVICE_STATUSES', SERVICE_STATUSES)
  .factory('DOCUMENT_STATUSES', DOCUMENT_STATUSES)
  .factory('DISABLED_SETTINGS', DISABLED_SETTINGS)
  .factory('SETTING_GROUPS', SETTING_GROUPS)
  .factory('EMPLOYEES_CONSTANTS', EMPLOYEES_CONSTANTS)
  .factory('COMBINATION_OPTIONS', COMBINATION_OPTIONS)
  .factory('RETENTION_LENGTH_OPTIONS', RETENTION_LENGTH_OPTIONS)
  .controller('MerchantPortalConfigurationController', MerchantPortalConfigurationController)
  .controller('OpeningTimesController', OpeningTimesController)
  .controller('SearchTagsController', SearchTagsController)
  .controller('MerchantImagesController', MerchantImagesController)
  .controller('ServicesController', ServicesController)
  .controller('ServicesTabsController', ServicesTabsController)
  .controller('AreasController', AreasController)
  .controller('EmployeesController', EmployeesController)
  .controller('GeneralSettingsController', GeneralSettingsController)
  .controller('CombinationsController', CombinationsController)
  .controller('RetentionSettingsController', RetentionSettingsController)
  .controller('DocumentsController', DocumentsController)
  .controller('ObjectsController', ObjectsController)
  .directive('ecCustomersCsv', ecCustomersCsv)
  .directive('appBlockTablesModal', downgradeComponent({ component: BlockTablesModalComponent }))
  .constant('MERCHANT_CONSTANTS', MERCHANT_CONSTANTS)
  .component('cuisinesTags', cuisinesTags).name;

export default merchantsModule;



// WEBPACK FOOTER //
// ./src/app/merchants/merchants.module.ajs.ts